import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-stage-deep blueprint text-center text-white" aria-label="Oferta por tiempo limitado" data-id="element-284" data-mp="369xubzheqcj6">
      <div className="hazard-bar h-3 w-full" aria-hidden="true" data-id="element-285" data-mp="31ipjcz0fij3w" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-286" data-mp="31h4plblxv473">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-danger" data-id="element-287" data-mp="3g72iu5yq6k35">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-288" data-mp="3b8iuy00kmy85" /> Precio de lanzamiento · cierra en
        </p>
        <h2 className="mt-2 font-display text-2xl font-extrabold sm:text-3xl" data-id="element-289" data-mp="3p80mgn594pl7">Tu ciclo lectivo puede estar listo hoy</h2>
        <Countdown light className="mt-6 scale-110" data-id="element-290" data-mp="3l5doe4hzm8fk" />
        <p className="mt-7 font-bold text-mutedDark" data-id="element-291" data-mp="1uvkar6tosj8y">Después sube. No vuelve al precio de lanzamiento.</p>
        <div className="panel-dark mx-auto mt-6 max-w-xl rounded-lg border border-steel p-4 text-sm" data-id="element-292" data-mp="1qurzk81984a1">
          <p className="font-bold" data-id="element-293" data-mp="2sv96fppu2yfh">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-danger" data-id="element-294" data-mp="2xsr42jyehr86" />
            Cupos al precio de lanzamiento: quedan pocos
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-black/40" data-id="element-295" data-mp="32qj5q5oukrpk">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '71%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-safety" data-id="element-296" data-mp="37jcct07sgc4t" />
          </div>
          <p className="mt-1 text-right text-xs text-mutedDark" data-id="element-297" data-mp="3lj4wwcot7u3t">71% tomados</p>
        </div>
      </div>
      <div className="hazard-bar h-3 w-full" aria-hidden="true" data-id="element-298" data-mp="3qgn706ekcfde" />
    </section>;
}